<template>
  <div class="headerView">
    <div class="header">
      <a-row justify="space-between">
        <div class="title">{{title}} <span class="tip">{{tip}}</span></div>
        <slot></slot>  
      </a-row>
    </div>
    <a-divider style="height: 1px; background-color: #eee;margin: 14px 0;" />
  </div>
</template>

<script>
export default {
  props: {
    title:String,
    tip: String
  },
  data() {
    return {

    }
  }
}
</script>

<style lang='less' scoped>
.title {
  font-size: 16px;
  font-weight: bolder;
}
.header {
  padding: 0 10px;
}
.tip {
  font-size: 14px;
  font-weight: 700;
}
</style>